/**
 * @fileoverview GET handler for the "/apps/transformations/package_detail" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appsTransformationsCacheKey } from "./constants";
import type { TransformationPackageDetail } from "./types";

export const getTransformationPackageDetail = reactQueryFetcherAdapter(
  appsTransformationsCacheKey,
  (): Promise<TransformationPackageDetail> => {
    return fetch(
      `/apps/transformations_package_detail`,
      "GET",
      {},
      {},
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
